// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Listbox, Transition} from '@headlessui/react';
import {useProductOptions} from '@shopify/hydrogen';
import clsx from 'clsx';
import {Fragment, ReactElement} from 'react';

import {ChevronDownIcon} from '~/components';

/**
 * A client component that tracks a selected variant and/or selling plan state, as well as callbacks for modifying the state
 */
export function ProductOptions(): ReactElement {
  const {options, setSelectedOption, selectedOptions} = useProductOptions();

  // for handling shopify default variant if we don't add any variant shopify adds a default variant
  if (
    options?.length === 1 &&
    options[0]?.name === 'Title' &&
    options[0].values?.length === 1 &&
    options[0].values[0] === 'Default Title'
  ) {
    return <></>;
  }

  return (
    <>
      {options?.map((option) => {
        const {name, values} = option ?? {};
        if (!name || !values) {
          return <></>;
        }

        return (
          <fieldset key={name}>
            <Listbox
              value={selectedOptions?.[name]}
              onChange={(value) => setSelectedOption(name, value)}
            >
              {({open}) => (
                <>
                  <Listbox.Label className="block text-sm font-medium text-gray-700">
                    {name === 'Type'
                      ? 'Service Type'
                      : name.replace('Add-On Refreshers', 'Add-On')}
                  </Listbox.Label>
                  <div className="relative mt-1">
                    <Listbox.Button
                      className={clsx(
                        'flex w-full transform appearance-none justify-between bg-clay-100 bg-clip-padding bg-no-repeat px-8 py-4 text-sm text-gray-900 duration-300 focus:border-black focus:ring-black',
                        open ? 'rounded-t-[1.5rem]' : 'rounded-[1.5rem]',
                      )}
                    >
                      {/* TODO - decide */}
                      <span className="block max-w-[230px] truncate border">
                        {selectedOptions?.[name]}
                      </span>
                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-8">
                        <ChevronDownIcon
                          fill="black"
                          className={clsx(
                            'transform duration-300',
                            open ? 'rotate-180' : '',
                          )}
                        />
                      </span>
                    </Listbox.Button>

                    <Transition
                      show={open}
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Listbox.Options className="absolute z-10 max-h-60 w-full overflow-auto rounded-b-[1.5rem] bg-clay-100 py-1 text-base shadow-md !outline-none sm:text-sm">
                        {values.map((value: string | undefined) => (
                          <Listbox.Option
                            key={value}
                            className={({active}) =>
                              clsx(
                                active
                                  ? 'bg-acai-900 text-white'
                                  : 'text-gray-900',
                                'relative cursor-pointer select-none py-2',
                              )
                            }
                            value={value}
                          >
                            {({selected}) => (
                              <>
                                <span
                                  className={clsx(
                                    selected ? 'font-semibold' : 'font-normal',
                                    'block truncate px-8',
                                  )}
                                >
                                  {value}
                                </span>
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </>
              )}
            </Listbox>
          </fieldset>
        );
      }) ?? null}
    </>
  );
}
